import Moment from 'moment';
import moment from 'moment/moment.js';

const ISO_DATE_FORMAT = 'YYYY-MM-DD';

function firstDayOfCurrentMonth(date: string = ''): string {
  return moment(date).startOf('month').format(ISO_DATE_FORMAT);
}

function lastDayOfCurrentMonth(date: string = ''): string {
  return moment(date).endOf('month').format(ISO_DATE_FORMAT);
}

function ISO_FORMAT(date: string): string {
  return moment(date, ISO_DATE_FORMAT).format(ISO_DATE_FORMAT);
}

function TODAY_ISO_FORMAT(): string {
  return moment().format(ISO_DATE_FORMAT);
}

function getMoment(date: string): moment.Moment {
  return Moment(date, ISO_DATE_FORMAT);
}

export {
  firstDayOfCurrentMonth,
  lastDayOfCurrentMonth,
  ISO_FORMAT,
  TODAY_ISO_FORMAT,
  getMoment,
};
